import React from "react"
import type { Node } from "react"

import { images } from "../../../config/image-definitions"

const {
    moderationApprovedImage: approvedIcon,
    moderationRejectedImage: rejectedIcon,
    suggestionToApproveImage: suggestApproveIcon,
    suggestionToRejectImage: suggestRejectIcon
} = images

type ModerationIconProps = {
    approved: boolean,
    approvalSuggestion: ?boolean,
    isButton: ?boolean
}

function ModerationIcon({
    approved,
    approvalSuggestion,
    isButton
}: ModerationIconProps): ?Node {
    let icon = null
    if (approved !== null && approved !== undefined) {
        icon = approved ? approvedIcon : rejectedIcon
    } else if (approvalSuggestion || approvalSuggestion === false) {
        icon = approvalSuggestion ? suggestApproveIcon : suggestRejectIcon
    }
    if (icon) {
        return (
            <i
                className={`moderation-icon ${
                    isButton ? "moderation-icon-button" : ""
                }`}
                style={{
                    backgroundImage: `url(${icon})`
                }}
            />
        )
    } else {
        return null
    }
}

export default ModerationIcon
